var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSocialSecurity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    stroke: "#0B966B",
    strokeWidth: 1.2,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0C5.76 0 4 1.65 4 3.75V6h8V3.75C12 1.65 10.24 0 8 0z"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 6,
    width: 16,
    height: 14,
    rx: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 12,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 14v2"
  }))));
}
export default SvgIconSocialSecurity;